export const range = function range(from, to) {
    return Array.from({ length: Math.max(0, to - from + 1) }, (_, i) => i + from)
}
